"use client";
/* 国家数据初始化 */
// React
import { useEffect } from "react";
// 公共方法
import { queryGlobalCountriesData, defaultLanguageList } from "@/utils/countryUtils";
import { getAddressCookie } from "@/utils/addressUtils";
import { setDefaultLocalAddress } from "@/utils/addressRequestUtils";
import cookieUtils from "@/utils/cookieUtils";
import { getI18nLang, setI18nLang } from "@/i18n/settings";
// 接口
import { Language, Currency, Address } from "@/apis/address/address.interface";
import { reportUserSwitchCountry } from "@/apis/login/login.api";
// 常量
// Store
import { useStores } from "@/models";
import { useRouter } from "next/navigation";

const CountryDataInitializer = () => {
  const { countryStore } = useStores();
  const router = useRouter();

  useEffect(() => {
    const initCountryData = async () => {
      try {
        //国家白名单
        const { currentCountryCode, currentCountry, countryList , hasPermission } = await queryGlobalCountriesData();
        
        // 语言货币
        const langCookie = getI18nLang();
        const currencyCookie = cookieUtils.getCookie("_currency");

        let supportLangList: Language[] = [];
        let supportCurrencyList: Currency[] = [];
        
        try {
          supportLangList = currentCountry?.languageList && 
            Array.isArray(currentCountry.languageList) && 
            currentCountry.languageList.length > 0
            ? currentCountry.languageList
            : defaultLanguageList;
            
          supportCurrencyList = currentCountry?.currencyList && 
            Array.isArray(currentCountry.currencyList) && 
            currentCountry.currencyList.length > 0
            ? currentCountry.currencyList
            : [];
        } catch (error) {
          supportLangList = defaultLanguageList;
          supportCurrencyList = [];
        }

        // 地址
        await setDefaultLocalAddress({
          currentCountry,
          currentCountryCode
        });
        const currentAddress = getAddressCookie() as Address;

        let currentLanguageCode = langCookie;
        if (!langCookie || !supportLangList?.some(lang => lang?.code === langCookie)) {
          // 语言不存在 或 语言不支持 需要替换为默认语言
          const lang = currentCountry?.language || supportLangList?.[0]?.code;
          if (lang) {
            setI18nLang(lang);
            currentLanguageCode = lang;
          }
        }
        const currentLanguageData = supportLangList.find(lang => lang?.code === currentLanguageCode) || supportLangList?.[0];

        let currentCurrencyCode = currencyCookie;
        if (!currencyCookie || !supportCurrencyList?.some(currency => currency?.code === currencyCookie)) {
          // 货币不存在 或 货币不支持 需要替换为默认货币
          const currency = currentCountry?.currency || supportCurrencyList?.[0]?.code;
          if (currency) {
            cookieUtils.setCookie("_currency", currency, 90);
            currentCurrencyCode = currency;
          }
        }
        const currentCurrencyData = supportCurrencyList.find(currency => currency.code === currentCurrencyCode) || supportCurrencyList?.[0];

        const initData = {
          currentCountryData: currentCountry,
          currentCountryCode,
          countryList,
          currentAddress,
          supportLanguageList: supportLangList,
          supportCurrencyList: supportCurrencyList,
          currentLanguageCode,
          currentLanguageData,
          currentCurrencyCode,
          currentCurrencyData
        }
        console.log('tttInitData',initData);
        
        // 更新全局状态
        countryStore.initCountryData(initData);

        reportUserSwitchCountry({
          siteCode: currentCountry?.siteCode,
          countryCode: currentCountryCode,
          languageCode: currentLanguageCode,
          currencyCode: currentCurrencyCode
        });

        // 白名单页面，不做权限跳转
        const whiteList = ['/login', '/jd-auth-redirect', '/ochama-auth-redirect', '/notAllowed','/forgot-password'];
        const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
        if(!hasPermission && !whiteList.includes(currentPath)){
          router.push('/notAllowed');
        }
        //有权限但是停留在notAllowed页面，回首页
        if(hasPermission&&currentPath==="/notAllowed"){
          router.push('/');
        }
      } catch (error) {
        console.error("国家列表数据初始化失败:", error);
      }
    };

    initCountryData();
  }, []);

  return null;
};

export default CountryDataInitializer;
